module.exports = __webpack_public_path__ + "img/home-icon-inactive.adfd267c.svg";